<div
  class="text-xs p-4 flex flex-col gap-4 bg-white text-neutral-90 h-full w-full border-t border-neutral-40 border-solid"
>
  @if (loading) {
    <maximizer-loader type="legacy"></maximizer-loader>
  }

  @if (!isCompany) {
    <div class="flex gap-4">
      <span class="font-bold w-1/3 shrink-0 min-w-16">
        {{ 'outlook.details.firstName' | translate }}:
      </span>
      <span class="min-w-0 truncate">{{ lead?.firstName ?? abentry?.firstName }}</span>
    </div>

    <div class="flex gap-4">
      <span class="font-bold w-1/3 shrink-0 min-w-16">
        {{ 'outlook.details.lastName' | translate }}:
      </span>
      <span class="min-w-0 truncate">{{ lead?.lastName ?? abentry?.lastName }}</span>
    </div>
  }

  <div class="flex gap-4">
    <span class="font-bold w-1/3 shrink-0 min-w-16">
      {{ 'outlook.details.company' | translate }}
      @if (isContact) {
        /{{ 'individual' | translateVertical }}:
      } @else {
        :
      }
    </span>
    <span class="min-w-0 truncate">
      @if (isContact) {
        {{ abentry?.parentDisplayValue ?? '' }}
      } @else {
        {{ lead?.companyName ?? abentry?.companyName }}
      }
    </span>
  </div>

  @if (!isCompany) {
    <div class="flex gap-4">
      <span class="font-bold w-1/3 shrink-0 min-w-16">
        {{ 'outlook.details.position' | translate }}:
      </span>
      <span class="min-w-0 truncate">{{ lead?.position ?? abentry?.position }}</span>
    </div>
  }

  <div class="flex gap-4">
    <span class="font-bold w-1/3 shrink-0 min-w-16">
      {{ 'outlook.details.website' | translate }}:
    </span>
    <span class="min-w-0 truncate">{{ lead?.website ?? abentry?.website }}</span>
  </div>

  <div class="flex flex-col gap-1">
    <span class="font-bold text-neutral-70">{{ 'outlook.details.phone' | translate }}:</span>
    @if (lead) {
      <div class="flex gap-4">
        <span class="font-bold w-1/3 shrink-0 min-w-16">
          {{ 'outlook.details.phoneType.phone1' | translate }}:
        </span>
        <span class="min-w-0 truncate">{{ lead.phone1 }}</span>
      </div>
      @if (lead.phone2 !== '') {
        <div class="flex gap-4">
          <span class="font-bold w-1/3 shrink-0 min-w-16">
            {{ 'outlook.details.phoneType.phone2' | translate }}:
          </span>
          <span class="min-w-0 truncate">{{ lead.phone2 }}</span>
        </div>
      }
    }
    @for (phone of abentry?.phones; track $index) {
      <div class="flex gap-4">
        <span class="font-bold w-1/3 shrink-0 min-w-16 truncate">
          {{
            phone.type !== ''
              ? phone.type
              : ('outlook.details.phone' | translate) + ' ' + phone.index
          }}:
        </span>
        <span class="min-w-0 truncate">{{ phone.value }}</span>
      </div>
    }
  </div>

  <div class="flex flex-col gap-1">
    <span class="font-bold text-neutral-70">{{ 'outlook.details.email' | translate }}:</span>
    @if (lead) {
      <div class="flex gap-4">
        <span class="font-bold w-1/3 shrink-0 min-w-16">
          {{ 'outlook.details.emailType.main' | translate }}:
        </span>
        <span class="min-w-0 truncate">{{ lead.email }}</span>
      </div>
    }
    @for (email of abentry?.emails; track $index) {
      <div class="flex gap-4">
        <span class="font-bold w-1/3 shrink-0 min-w-16 truncate">
          {{
            email.type !== ''
              ? email.type
              : ('outlook.details.email' | translate) + ' ' + email.index
          }}:
        </span>
        <span class="min-w-0 truncate">{{ email.value }}</span>
      </div>
    }
  </div>

  <div class="flex gap-4">
    <span class="font-bold w-1/3 shrink-0 min-w-16">
      {{ 'outlook.details.address' | translate }}:
    </span>
    <span class="min-w-0 break-all whitespace-pre-line">{{ getAddress() }}</span>
  </div>
</div>

<maximizer-outlook-notification
  #notification
  [closable]="true"
  entryId="details"
>
</maximizer-outlook-notification>
